import { makeStyles, Theme, createStyles } from '@material-ui/core/styles'
import { colors } from 'Themes/Colors'
import { colors as birdsong } from '@resiliatech/birdsong'

const panelWidthMd = '40%'
const panelWidthLg = 616

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    titleWrapper: {
      display: 'flex',
      marginBottom: '20px',
      '& h1': {
        color: birdsong.copy.headerDark,
      },
    },
    pageTitle: {
      marginBottom: 20,
      alignItems: 'center',
    },
    button: {
      marginLeft: 'auto',
      display: 'flex',
    },
    limitSection: {
      display: 'flex',
      width: '100%',
      fontSize: 12.8,
      weight: 700,
      color: colors.darkGrey,
      justifyContent: 'space-between',
      marginBottom: '20px',

      [theme.breakpoints.down('sm')]: {
        justifyContent: 'flex-start',
      },
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column',
      },
    },
    info: {
      fontSize: 18,
      marginRight: 10,
      marginLeft: 15,
      color: colors.darkGrey,
    },
    pagePanelClosed: {
      width: `100%`,
      transition: 'all 0.2s ease-in-out',
    },
    pagePanelOpen: {
      transition: 'all 0.13s ease-in-out',
      '@media (min-width: 1280px)': {
        width: `calc(100% - ${panelWidthMd})`,
        marginRight: panelWidthMd,
      },
      '@media (min-width: 1780px)': {
        width: `calc(100% - ${panelWidthLg}px)`,
        marginRight: panelWidthLg,
      },
    },
    requestButton: {
      marginRight: '1rem',
    },
    savedSnackbar: {
      '& .MuiSnackbarContent-root': {
        background: colors.greyBlue,
        height: '46px',
        justifyContent: 'center',
      },
      '& .MuiSnackbarContent-message': {
        fontWeight: 400,
        fontSize: '16px',
        color: colors.resiliaWhite,
        textAlign: 'center',
        lineHeight: '135%',
        justifyContent: 'center',
      },
    },
    example: {
      cursor: 'pointer',
      marginRight: '20px',
      fontSize: '14px',
      fontWeight: 400,
      color: colors.black,
      '&:hover': {
        textDecoration: 'underline',
      },
    },
    infoIcon: {
      cursor: 'pointer',
      fontSize: '20px',
      marginRight: 10,
      marginLeft: 15,
      color: colors.darkGrey,
      '&:hover': {
        color: colors.blue,
      },
    },
  })
)

export default useStyles
